
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit: function (e, page) {
      var self = this;
      var app = self.$app;
      var $$ = self.$;
      var searchTimeout = null;
      var ctx = page.route.context || {};
      var partnerType = ctx.partnerType || '';
      var listEndpoint = ctx.listEndpoint || 'doctors?city=' + (localStorage.getItem('city') || '');
      var perPage = ctx.perPage || 10;
      var currentPage = ctx.currentPage || 1;
      var hasMore = !!ctx.hasMore;
      var loadingMore = false;
      if (partnerType == '1') {
        $$('#searchPageTitle').text('Partner Doctors');
      }
      function esc(s) {
        if (s === null || s === undefined)
          return '';
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      function renderDoctorCard(doctor) {
        var dpImage = doctor.dp_url ? doctor.dp_url : 'static/img/default_doctor.svg';
        var departmentName = doctor.dep_name || doctor.department_name || '';
        var verifiedChip = doctor.isPartnerDoctor == 1 ? '<a href="#" class="doctor-verified-chip partner-info-btn" aria-label="mDOC Verified Partner \u2014 tap to learn more">' + '<i class="icon f7-icons if-not-md doctor-verified-chip-seal">checkmark_seal_fill</i>' + '<i class="icon material-icons md-only doctor-verified-chip-seal">verified</i>' + '<span class="doctor-verified-chip-text">mDOC Verified</span>' + '</a>' : '';
        var bookBtn = doctor.preLive == 0 ? '<button type="button" class="doctor-card-book doctor-card-book-disabled" disabled>Currently unavailable</button>' : '<a href="/booking/' + esc(doctor.id) + '/Normal/" class="doctor-card-book link">Book appointment</a>';
        var degreeHtml = doctor.degree ? '<div class="doctor-card-degree">' + esc(doctor.degree) + '</div>' : '';
        var deptChip = departmentName ? '<span class="doctor-card-chip doctor-card-chip-dept">' + esc(departmentName) + '</span>' : '';
        var expChip = doctor.experiance ? '<span class="doctor-card-chip doctor-card-chip-exp">' + esc(doctor.experiance) + '+ yr exp</span>' : '';
        var addressHtml = doctor.address ? '<div class="doctor-card-hospital-address">' + esc(doctor.address) + '</div>' : '';
        var directionLink = doctor.lat ? '<a class="doctor-card-direction link external" href="https://www.google.com/maps/place/' + esc(doctor.lat) + '+' + esc(doctor.log) + '" target="_system" aria-label="Get directions"><i class="icon material-icons">directions</i></a>' : '';
        var hospitalBlock = doctor.hospital_name ? '<div class="doctor-card-hospital">' + '<div class="doctor-card-hospital-info">' + '<i class="icon f7-icons if-not-md">house_fill</i>' + '<i class="icon material-icons md-only">local_hospital</i>' + '<div>' + '<div class="doctor-card-hospital-name">' + esc(doctor.hospital_name) + '</div>' + addressHtml + '</div>' + '</div>' + directionLink + '</div>' : '';
        var partnerClass = doctor.isPartnerDoctor == 1 ? ' is-partner' : '';
        return '' + '<div class="doctor-card' + partnerClass + '">' + '<div class="doctor-card-top">' + '<div class="doctor-card-photo">' + '<img src="' + esc(dpImage) + '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">' + '</div>' + '<div class="doctor-card-info">' + '<div class="doctor-card-name">Dr. <span class="doctorNameSearch">' + esc(doctor.name) + '</span></div>' + verifiedChip + degreeHtml + '<div class="doctor-card-meta">' + deptChip + expChip + '</div>' + '</div>' + '<div class="doctor-card-fee">' + '<div class="doctor-card-fee-label">Fee</div>' + '<div class="doctor-card-fee-amount">\u20B9' + esc(doctor.fee) + '</div>' + '</div>' + '</div>' + hospitalBlock + '<div class="doctor-card-actions">' + bookBtn + '</div>' + '</div>';
      }
      function loadNextPage() {
        if (loadingMore || !hasMore)
          return;
        loadingMore = true;
        $$('#doctorInfinitePreloader').show();
        var nextPage = currentPage + 1;
        var url = app.data.remoteUrl + listEndpoint + '&page=' + nextPage + '&per_page=' + perPage;
        app.request({
          url: url,
          method: 'GET',
          dataType: 'json',
          success: function (response) {
            $$('#doctorInfinitePreloader').hide();
            loadingMore = false;
            var list = response && response.data ? response.data : [];
            var meta = response && response.meta ? response.meta : {};
            if (list.length) {
              var html = '';
              list.forEach(function (d) {
                html += renderDoctorCard(d);
              });
              $$('#initialDoctorList').append(html);
              currentPage = nextPage;
              hasMore = !!meta.has_more;
              if (!hasMore) {
                app.infiniteScroll.destroy('#doctorSearchPage');
              }
            } else {
              hasMore = false;
              app.infiniteScroll.destroy('#doctorSearchPage');
            }
          },
          error: function () {
            $$('#doctorInfinitePreloader').hide();
            loadingMore = false;
          }
        });
      }
      function showInitialList() {
        $$('#doctorListContainer').show();
        $$('#searchResultsList').hide();
        $$('#searchNotFound').hide();
      }
      function showSearchResults() {
        $$('#doctorListContainer').hide();
      }
      function performSearch(query) {
        if (!query || query.length < 2) {
          showInitialList();
          return;
        }
        app.preloader.show();
        var city = localStorage.getItem('city') || '';
        var url = app.data.remoteUrl + 'doctors?city=' + encodeURIComponent(city) + '&name=' + encodeURIComponent(query);
        if (partnerType == '1' || partnerType == '0') {
          url += '&isPartnerDoctor=' + partnerType;
        }
        app.request({
          url: url,
          method: 'GET',
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            showSearchResults();
            var data = response && response.data ? response.data : response || [];
            if (data && data.length > 0) {
              var html = '';
              data.forEach(function (doctor) {
                html += renderDoctorCard(doctor);
              });
              $$('#searchResultsList').html(html).show();
              $$('#searchNotFound').hide();
            } else {
              $$('#searchResultsList').hide();
              $$('#searchNotFound').show();
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      }
      $$('#doctorSearchInput').on('input', function () {
        var query = $$(this).val().trim();
        if (searchTimeout)
          clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
          performSearch(query);
        }, 500);
      });
      $$('#clearSearchBtn').on('click', function () {
        $$('#doctorSearchInput').val('');
        showInitialList();
      });
      $$('#doctorSearchForm').on('submit', function (e) {
        e.preventDefault();
        var query = $$('#doctorSearchInput').val().trim();
        performSearch(query);
      });
      if (hasMore) {
        $$('#doctorSearchPage').on('infinite', loadNextPage);
      }
    }
  },
  id: '9a8d624ac6',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page doctor-list-page" data-name="DoctorList" id="DoctorListPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title" id="searchPageTitle">\n                    ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.partnerType == \'1\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'Partner Doctors';
          r += Template7Helpers.js_if.call(ctx_2, 'this.partnerType == \'0\'', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += Template7Helpers.js_if.call(ctx_2, 'this.partnerType == \'0\'', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'Doctors';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'Doctors';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n            </div>\n        </div>\n\n        <div class="page-content infinite-scroll-content" id="doctorSearchPage" data-infinite-distance="80">\n            <div class="doctor-list-search-wrap">\n                <form class="searchbar searchbar-inline" id="doctorSearchForm">\n                    <div class="searchbar-inner">\n                        <div class="searchbar-input-wrap">\n                            <i class="icon f7-icons if-not-md mdoc-sb-icon">search</i>\n                            <i class="icon material-icons md-only mdoc-sb-icon">search</i>\n                            <input type="search" id="doctorSearchInput" placeholder="Search by doctor name\u2026">\n                            <span class="input-clear-button" id="clearSearchBtn"></span>\n                        </div>\n                    </div>\n                </form>\n            </div>\n\n            <!-- Initial paginated list (default view) -->\n            <div id="doctorListContainer">\n                ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data && this.data.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="doctor-list-count" id="doctorListCount">';
          r += c(ctx_2.total, ctx_2);
          r += ' doctor';
          r += Template7Helpers.js_if.call(ctx_2, 'this.total > 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 's';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' found</div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                <div class="doctor-list" id="initialDoctorList">\n                    ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <div class="doctor-card';
          r += Template7Helpers.js_if.call(ctx_2, 'this.isPartnerDoctor == 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' is-partner';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">\n                        <div class="doctor-card-top">\n                            <div class="doctor-card-photo">\n                                <img src="';
          r += Template7Helpers.if.call(ctx_2, ctx_2.dp_url, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += c(ctx_3.dp_url, ctx_3);
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'static/img/default_doctor.svg';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">\n                            </div>\n                            <div class="doctor-card-info">\n                                <div class="doctor-card-name">Dr. <span class="doctorNameSearch">';
          r += c(ctx_2.name, ctx_2);
          r += '</span></div>\n                                ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.isPartnerDoctor == 1', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <a href="#" class="doctor-verified-chip partner-info-btn" aria-label="mDOC Verified Partner \u2014 tap to learn more">\n                                    <i class="icon f7-icons if-not-md doctor-verified-chip-seal">checkmark_seal_fill</i>\n                                    <i class="icon material-icons md-only doctor-verified-chip-seal">verified</i>\n                                    <span class="doctor-verified-chip-text">mDOC Verified</span>\n                                </a>\n                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.degree', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                <div class="doctor-card-degree">';
              r += c(ctx_3.degree, ctx_3);
              r += '</div>\n                                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                <div class="doctor-card-meta">\n                                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.dep_name', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <span class="doctor-card-chip doctor-card-chip-dept">';
              r += c(ctx_3.dep_name, ctx_3);
              r += '</span>\n                                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                    ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.experiance', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <span class="doctor-card-chip doctor-card-chip-exp">';
              r += c(ctx_3.experiance, ctx_3);
              r += '+ yr exp</span>\n                                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                </div>\n                            </div>\n                            <div class="doctor-card-fee">\n                                <div class="doctor-card-fee-label">Fee</div>\n                                <div class="doctor-card-fee-amount">\u20B9';
          r += c(ctx_2.fee, ctx_2);
          r += '</div>\n                            </div>\n                        </div>\n\n                        ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.hospital_name', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="doctor-card-hospital">\n                            <div class="doctor-card-hospital-info">\n                                <i class="icon f7-icons if-not-md">house_fill</i>\n                                <i class="icon material-icons md-only">local_hospital</i>\n                                <div>\n                                    <div class="doctor-card-hospital-name">';
              r += c(ctx_3.hospital_name, ctx_3);
              r += '</div>\n                                    ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.address', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                                    <div class="doctor-card-hospital-address">';
                  r += c(ctx_4.address, ctx_4);
                  r += '</div>\n                                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                                </div>\n                            </div>\n                            ';
              r += Template7Helpers.js_if.call(ctx_3, 'this.lat', {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                            <a class="doctor-card-direction link external" href="https://www.google.com/maps/place/';
                  r += c(ctx_4.lat, ctx_4);
                  r += '+';
                  r += c(ctx_4.log, ctx_4);
                  r += '" target="_system" aria-label="Get directions">\n                                <i class="icon material-icons">directions</i>\n                            </a>\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                        </div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                        <div class="doctor-card-actions">\n                            ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.preLive == 0', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <button type="button" class="doctor-card-book doctor-card-book-disabled" disabled>Currently unavailable</button>\n                            ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <a href="/booking/';
              r += c(ctx_3.id, ctx_3);
              r += '/Normal/" class="doctor-card-book link">Book appointment</a>\n                            ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        </div>\n                    </div>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n\n                <!-- Infinite scroll preloader -->\n                <div class="preloader infinite-scroll-preloader" id="doctorInfinitePreloader" style="display: none;">\n                    <span class="preloader-inner">\n                        <span class="preloader-inner-gap"></span>\n                        <span class="preloader-inner-left"><span class="preloader-inner-half-circle"></span></span>\n                        <span class="preloader-inner-right"><span class="preloader-inner-half-circle"></span></span>\n                    </span>\n                </div>\n\n                <!-- Empty initial list -->\n                ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.data.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="empty-state" id="initialEmptyState">\n                    <img src="static/img/no_doctor.svg" alt="">\n                    <div class="empty-state-title">No doctors available</div>\n                    <div class="empty-state-sub">Please check back later.</div>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n\n            <!-- Search Results -->\n            <div class="doctor-list" id="searchResultsList" style="display: none;"></div>\n\n            <!-- Nothing found -->\n            <div class="empty-state" id="searchNotFound" style="display: none;">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">No doctor matches your search</div>\n                <div class="empty-state-sub">Try a different name or check spelling.</div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    